module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"是否进行删除操作？":"This will permanently delete the data. Continue?"}}')
  delete Component.options._Ctor
}
